<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openTabulationForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="tabulations"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.status }}</td>
        <td class="text-xs-right">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openTabulationForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-tooltip bottom v-if="props.item.status !== 'disabled'">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="error"
                >
                  cancel
                </v-icon>
              </v-btn>
            </template>
            <span>Desativar Tabulação</span>
          </v-tooltip>

          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="success"
                >
                  task
                </v-icon>
              </v-btn>
            </template>
            <span>Reativar Tabulação</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_modify_status_tabulation" max-width="290" dark>
      <v-card color="grey">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ newTabulationStatus !== "disabled" ? "ativar" : "desativar" }} essa
          tabulação?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red"
            @click="dialog_modify_status_tabulation = false"
            dark
          >
            Não
          </v-btn>

          <v-btn color="green" dark @click="reactivateOrDesactivate()">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <tabulation-form />
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { eventBus } from "@/main";
import { updateTabulationFb } from "../../services/tabulations";
import TabulationForm from "./TabulationForm.vue";

export default {
  components: { TabulationForm },
  data() {
    return {
      search: "",
      dialog_modify_status_tabulation: false,
      newTabulationStatus: null,
      tabulationId: null,
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Status",
          value: "status",
        },
      ],
      pag: {
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapState("configuration", ["loading", "tabulations"]),
  },
  mounted() {
    this.getTabulations();
  },
  methods: {
    ...mapActions("configuration", ["getTabulations"]),

    startUpdate(id, status) {
      if (status === "disabled") status = "activated";
      else status = "disabled";

      ((this.newTabulationStatus = status), (this.tabulationId = id));
      this.dialog_modify_status_tabulation = true;
    },

    reactivateOrDesactivate() {
      if (this.newTabulationStatus === "disabled") {
        this.deleteTabulation(this.tabulationId);
        this.dialog_modify_status_tabulation = false;
      } else {
        this.reactivateTabulation(this.tabulationId);
        this.dialog_modify_status_tabulation = false;
      }
    },

    deleteTabulation(id) {
      let data = {
        updated_at: new Date(),
        status: "disabled",
      };
      updateTabulationFb(id, data);
    },

    reactivateTabulation(id) {
      let data = {
        updated_at: new Date(),
        status: "activated",
      };
      updateTabulationFb(id, data);
    },

    openTabulationForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
      };
      eventBus.$emit("tabulationForm", obj);
    },
  },
};
</script>
